import React, { useEffect, useState, useRef } from 'react';

import { useAuthenticator } from '@aws-amplify/ui-react';
import { Auth, API } from 'aws-amplify';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDriverQualificationRoleId } from '../../graphql/customQueries';
import { useDispatch } from 'react-redux';

import { setSelectedRoleId } from '../Dashboard/dashboardSlice';

import Authenticator from '../Login/AuthContainer';
import MFACode from '../Login/MFACode';
import VerifyMFACode from '../Login/VerifyMFACode';

import './styles.scoped.css';

const VerifyDQFAuthLink = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentIndex = useRef(0);
  const getCognitoUserCalled = useRef(false);
  const [requiredAttributes, setRequiredAttributes] = useState([]);
  const [userData, setUserData] = useState({
    code: '',
    verifyCode: '',
    username: '',
    nextStep: 'Code',
  });

  const params = new URLSearchParams(location.search);
  const [dqf, email] = [params.get('dqf') || '', params.get('email') || ''];

  const { route } = useAuthenticator(context => [context.route]);

  const getCognitoUser = async () => {
    try {
      if (email) {
        await Auth.signIn(email).then(user => {
          if (user.challengeName === 'CUSTOM_CHALLENGE') {
            if (user.challengeParam.customMfaChallenge === 'PICK_MFA_FACTOR') {
              setRequiredAttributes(JSON.parse(user.challengeParam.publicChallengeParameters));
              nextStep({
                ...userData,
                nextStep: 'MFACode',
                user: user,
                username: email,
              });
            }
          }
        });
      }
    } catch (e) {
      console.log('e', e);
    }
  };

  const nextStep = stepData => {
    setUserData({ ...userData, ...stepData });
  };

  useEffect(() => {
    if (dqf && route === 'authenticated') {
      const redirectToDqf = async () => {
        try {
          const response = await API.graphql({
            query: getDriverQualificationRoleId,
            variables: { id: email },
          });
          const items = response?.data?.getUser?.appAccess?.items ?? [];
          const roleId = items[0]?.roleId?.id ?? 2;
          dispatch(setSelectedRoleId(roleId));
        } catch (e) {
          dispatch(setSelectedRoleId(2));
        }
        navigate(`/driver-qualification/view-dqf/${dqf}`);
      };
      redirectToDqf();
    } else if (dqf && email && route !== 'authenticated' && !getCognitoUserCalled.current) {
      getCognitoUserCalled.current = true;
      getCognitoUser();
    }
  }, [route, navigate]);

  return (
    <>
      <Authenticator currentIndex={currentIndex.current} nextStep={nextStep}>
        {userData?.nextStep === 'MFACode' && requiredAttributes && (
          <MFACode
            getCognitoUser={getCognitoUser}
            nextStep={nextStep}
            requiredAttributes={requiredAttributes}
            userData={userData}
          />
        )}
        {userData?.nextStep === 'VerifyCode' && <VerifyMFACode nextStep={nextStep} userData={userData} />}
      </Authenticator>
    </>
  );
};

export default VerifyDQFAuthLink;
